import Site from '@app/api/site/site.actions';

export const getResources = async () => {
  return await Site.getAll();
}
